/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/app/_shared/shared.module';
import { DataListModule } from 'src/app/_components/data-list/data-list.module';
import { PinSelectComponent } from './pin-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    DataListModule,
  ],
  declarations: [PinSelectComponent],
  exports: [PinSelectComponent],
})
export class PinSelectModule {}
